var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.content,"config":_vm.editorConfig},on:{"blur":_vm.onBlurClick,"input":_vm.changeContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }